import React from 'react';
import connect from 'Shared/connect';
import Modal from 'Shared/Modal';
import InfoModalComponent from './Components/InfoModalComponent';
import { epiPropertyValue } from '@avensia/nitro5-scope-episerver';
import { isBrowser } from 'Shared/device-type';
import Dialog, { DialogType } from 'Shared/Dialog';
class InfoModal extends React.Component {
    constructor(props) {
        super(props);
        this.closeInfoModal = () => {
            this.setState({ isOpen: false });
        };
        this.confirmInfoModal = () => {
            document.cookie = 'hasShownInfoModal=' + this.getPageId() + '; path=/;SameSite=None;secure';
            this.closeInfoModal();
        };
        this.state = {
            isOpen: false,
        };
    }
    componentDidMount() {
        this.shouldShowInfoModal();
    }
    getCookie(cookiename) {
        if (!isBrowser()) {
            return '';
        }
        let cookiestring = RegExp('' + cookiename + '[^;]+').exec(document.cookie);
        return decodeURI(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./, '') : '');
    }
    getPageId() {
        return epiPropertyValue(this.props.headerViewModel &&
            this.props.headerViewModel.infoModalPage &&
            this.props.headerViewModel.infoModalPage.workId);
    }
    shouldShowInfoModal() {
        const pageId = this.getPageId();
        return (!!this.props.headerViewModel.infoModalPage &&
            this.getCookie('hasShownInfoModal') !== pageId &&
            this.getCookie('hideInfoModal') !== pageId);
    }
    render() {
        return (React.createElement(Modal, { onClose: this.closeInfoModal, isOpen: this.state.isOpen },
            React.createElement(InfoModalComponent, Object.assign({}, this.props.headerViewModel.infoModalPage)),
            React.createElement(Dialog, { type: DialogType.OkOnly, onConfirm: this.confirmInfoModal, onCancel: this.closeInfoModal })));
    }
}
export default connect((state) => ({
    headerViewModel: state.appShellData.header,
}))(InfoModal);
